var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tw-flex tw-items-center tw-flex-wrap"},[_c('a',{staticClass:"tw-text-primary link",attrs:{"href":_vm.specification.value},on:{"click":_vm.linkClicked}},[_vm._v("\n    "+_vm._s(_vm.displayLink)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }